<template>
    <div class="form-group clearfix">
        <div class="col-md-12">
            <label>Введите номера или треки заказов через пробел:</label>
            <input
                    type="text"
                    name="order_params"
                    v-model="order_params"
                    class="form-control"
                    autocomplete="off"
            >
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                order_params: ''
            };
        },
        watch: {
            'order_params' : function(val) {
                this.$root.$emit('update:order_params', val);
            }
        }
    }
</script>
